<script lang="ts">
import { lateinit } from 'tg-commons'
import { TrafficLayer } from 'tg-map-core'
import { defineComponent } from 'vue'
import MapMixin from '../map-mixin'
export default defineComponent({
  name: 'tg-traffic-layer',
  mixins: [MapMixin],
  // 请直接使用v-if来控制它的显隐
  // 没有属性时, 写`{}`类型推断会有问题, 故注释掉
  // props: {} satisfies Props<{}>,
  setup() {
    return {
      layer: lateinit<TrafficLayer>(),
    }
  },
  watch: {

  },
  onCreate() {
    this.layer = new TrafficLayer()
    this.$map.addLayer(this.layer)
  },
  onDestroy() {
    this.$map.removeLayer(this.layer)
  },
})

</script>
